import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const TableBodyStyled = styled.section`
  ${({ theme }) => css`
    overflow: hidden;
  `}
`;
